import { motion } from "framer-motion";

const questions = [
  "Can we sustain this pace?",
  "Are we okay — really?",
  "What will next week actually cost us?",
  "Where is our recovery time hiding?",
  "What did we say yes to that we can't hold?",
  "Who is carrying more than they can name?",
  "What breaks if one thing goes wrong?",
];

export default function Problem() {
  return (
    <section
      data-testid="problem-section"
      className="relative border-t border-rule bg-deep/40 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-14 md:grid-cols-12 md:gap-12">
          <div className="md:col-span-5">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-teal">
              01 — The problem
            </p>
            <h2 className="mt-6 font-display text-4xl leading-[1.05] text-ink md:text-5xl">
              Every calendar is full.
              <br />
              <span className="italic text-mist">
                No one is watching the horizon.
              </span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-mist">
              Modern families run on a dozen fragmented apps — each one polite,
              each one asking for more. The tools track tasks. Nobody tracks{" "}
              <span className="text-ink">capacity</span>. Nobody protects{" "}
              <span className="text-ink">recovery</span>. And nobody answers the
              questions that actually matter.
            </p>
          </div>

          <div className="md:col-span-7">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
              Seven questions families ask without tools
            </p>
            <ul className="mt-6 divide-y divide-rule border-t border-b border-rule">
              {questions.map((q, i) => (
                <motion.li
                  key={q}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{
                    duration: 0.6,
                    delay: i * 0.06,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  className="flex items-baseline gap-6 py-4"
                >
                  <span className="font-mono text-[10px] tracking-[0.22em] text-teal">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-xl leading-snug text-ink md:text-2xl">
                    {q}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
